/**
 * KAN-718: секция "Приём и отправка корреспонденции" на вкладке "Интеграции".
 * Ящик для переписки с клиентами (бот пишет с него и получает в него ответы).
 * Отдельной вкладки "Почта" больше нет: старые ссылки ?tab=mail открывают
 * "Интеграции" и прокручивают сюда (focus=true).
 */
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Inbox, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MailboxSettings } from './MailboxSettings';

export const MAILBOX_SECTION_ID = 'mailbox-section';

interface MailboxSectionProps {
  /** Прокрутить к секции при открытии (переход по старой ссылке ?tab=mail). */
  focus?: boolean;
}

export function MailboxSection({ focus = false }: MailboxSectionProps): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focus) ref.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  }, [focus]);

  return (
    <Card id={MAILBOX_SECTION_ID} ref={ref} data-testid={MAILBOX_SECTION_ID}>
      <CardHeader className="space-y-1">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <CardTitle className="text-lg flex items-center gap-2">
            <Inbox className="w-5 h-5" />
            Приём и отправка корреспонденции
          </CardTitle>
          <Link
            to="/emails"
            data-testid="mailbox-open-emails"
            className="inline-flex items-center gap-1 text-sm text-blue-600 hover:underline">
            Открыть почтовый ящик
            <ExternalLink className="h-3.5 w-3.5" />
          </Link>
        </div>
        <p className="text-sm text-muted-foreground" data-testid="mailbox-section-subtitle">
          Ящик для переписки с клиентами: с него бот пишет клиентам и из него получает их ответы.
          Уведомления для вас настраиваются ниже, в Email-уведомления.
        </p>
      </CardHeader>
      <CardContent>
        <MailboxSettings />
      </CardContent>
    </Card>
  );
}
